import { fromJS } from 'immutable';

import { CHANGE_SERVICE_TABLE_SEARCH, TOGGLE_SERVICE_VIEW, TOGGLE_SERVICE_FORM } from 'constants/ActionTypes';

const initialState = fromJS({
  search: null,
  view: {
    isVisible: false,
    serviceId: null,
  },
  form: {
    isVisible: false,
    serviceId: null,
    callback: null,
  },
});

const serviceTableReducer = (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_SERVICE_TABLE_SEARCH:
      return state.set('search', action.search);
    case TOGGLE_SERVICE_VIEW:
      if (state.getIn(['view', 'isVisible'])) {
        return state.merge(
          fromJS({
            view: {
              isVisible: false,
              serviceId: null,
            },
          }),
        );
      } else {
        return state.merge(
          fromJS({
            view: {
              isVisible: true,
              serviceId: action.serviceId,
            },
          }),
        );
      }
    case TOGGLE_SERVICE_FORM:
      if (state.getIn(['form', 'isVisible'])) {
        return state.merge(
          fromJS({
            form: {
              isVisible: false,
              serviceId: null,
              callback: null,
            },
          }),
        );
      } else {
        return state.merge(
          fromJS({
            form: {
              isVisible: true,
              serviceId: action.serviceId,
              callback: action.callback,
            },
          }),
        );
      }
    default:
      return state;
  }
};

export default serviceTableReducer;
